import PropTypes from 'prop-types';
import React from 'react';
import {
  Badge,
} from 'react-bootstrap';
import { findById } from '../../../core/utils';
import TourRosterGroups from './TourRosterGroups';
import TourRosterToolbar from './TourRosterToolbar';
import TourRosterTable from './TourRosterTable';
import MemberDetailModal from './MemberDetailModal';
import ImportRosterModal from './ImportRosterModal';

class TourRosterTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      showImport: false,
    };
    this.handleRemoveMember = this.handleRemoveMember.bind(this);
    this.handleShowMember = this.handleShowMember.bind(this);
    this.handleShowImport = this.handleShowImport.bind(this);
    this.closeImport = this.closeImport.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  componentWillMount() {
    console.log('In TourRosterTab.componentWillMount() ');
  }
  closeModal() {
    this.setState({
      show: false,
    });
  }
  closeImport() {
    this.setState({
      showImport: false,
    });
  }
  handleRemoveMember(e) {
    console.log('in handleRemoveMember ');
    const id = e.currentTarget.getAttribute('data-item');
    e.preventDefault();
    if (id) {
      const member = this.findUser(id);
      console.log('remove user from group: ', id, member.group.id);
      this.props.dispatchRemoveMemberFromGroup(member.group.id, id);
      // this.props.removeUserFromGroup(id, group.id);
    }
  }
  handleShowImport(e) {
    e.preventDefault();
    this.setState({
      showImport: true,
    });
  }
  handleShowMember(e) {
    e.preventDefault();
    console.log('handleShowMember: select user');
    const id = e.currentTarget.getAttribute('data-item');
    if (id) {
      console.log('show user: ', id);
      this.setState({
        user: id,
        show: true,
      });
    } else {
      console.log('show add user!');
      this.setState({
        user: -1,
        show: true,
      });
    }
  }
  findUser(id) {
    const idx = this.props.tour.members.findIndex(findById, id);
    if (idx === -1) {
      console.log('that should not happen... findUser: ', id);
      return {};
    }
    return this.props.tour.members[idx];
  }

  render() {
    return (
      <div className="col-sm-12 planner">
        <div className="roster-groups">
          <TourRosterGroups
            groups={this.props.tour.groups}
            removeGroup={this.props.removeGroup}
            editGroup={this.props.editGroup}
            readOnly={this.props.readOnly}
          />
          <TourRosterToolbar
            tour={this.props.tour}
            newGroup={this.props.newGroup}
            importRoster={this.props.importRoster}
            handleAddMember={this.handleShowMember}
            handleShowImport={this.handleShowImport}
            readOnly={this.props.readOnly}
            dispatchRemoveMemberFromGroup={this.props.dispatchRemoveMemberFromGroup}
          />

        </div>
        <div className="members-groups">
          <h3>Members <Badge>{this.props.tour.members.length}</Badge></h3>
          <TourRosterTable
            members={this.props.tour.members}
            handleRemoveMember={this.handleRemoveMember}
            handleEditMember={this.handleShowMember}
            readOnly={this.props.readOnly}
          />
          { this.state.showImport && (
            <ImportRosterModal
              tourId={this.props.tour.id}
              importRoster={this.props.importRoster}
              onClose={this.closeImport}
              show={this.state.showImport}
            />
          )}
          { this.state.show && (
            <MemberDetailModal
              tourId={this.props.tour.id}
              member={this.findUser(this.state.user)}
              show={this.state.show}
              onClose={this.closeModal}
              addMember={this.props.addMember}
              editMember={this.props.editMember}
              groups={this.props.tour.groups}
              readOnly={this.props.readOnly}
              dispatchRemoveMemberFromGroup={this.props.dispatchRemoveMemberFromGroup}
            />
          )}
        </div>
      </div>
    );
  }
}
TourRosterTab.propTypes = {
  tour: PropTypes.object.isRequired,
  newGroup: PropTypes.func.isRequired,
  removeGroup: PropTypes.func.isRequired,
  editGroup: PropTypes.func.isRequired,
  addMember: PropTypes.func.isRequired,
  editMember: PropTypes.func.isRequired,
  importRoster: PropTypes.func.isRequired,
  dispatchRemoveMemberFromGroup: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
};
TourRosterTab.defaultProps = {
  readOnly: false,
};
export default TourRosterTab;



// WEBPACK FOOTER //
// src/routes/tours/components/TourRosterTab.js